import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xl" }, " Cortizo proformy ", -1)
const _hoisted_2 = { class: "field grid align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "number-of-proform",
  class: "mb-0 col-fixed",
  style: {"width":"130px"}
}, "Číslo proformy", -1)
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = {
  class: "col-fixed add-cortizo",
  style: {"width":"150px"}
}
const _hoisted_6 = { class: "pt-1 pb-1 flex flex-wrap gap-1" }
const _hoisted_7 = { class: "w-10 align-items-center" }
const _hoisted_8 = { class: "text-600 text-base font-medium border-bottom-1" }
const _hoisted_9 = { class: "w-2 justify-content-center align-items-center flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!

  return (_openBlock(), _createBlock(_component_PrimevueCard, { class: "w-full mt-2" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_InputText, {
            class: _normalizeClass(["w-full", `${$setup.v$.proform.code.$error ? 'bg-red-200' : ''}`]),
            invalid: $setup.v$.proform.code.$error,
            modelValue: this.proform.code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.proform.code) = $event)),
            type: "text",
            name: "number-of-proform",
            id: "number-of-proform"
          }, null, 8, ["class", "invalid", "modelValue"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.proform.code.$errors, (error, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-sm font-italic text-red-400"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PrimevueButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.addProform())),
            label: "Pridať",
            severity: "success",
            icon: "pi pi-plus-circle",
            text: "",
            raised: "",
            class: "w-full uppercase"
          })
        ])
      ]),
      _createVNode(_component_Fieldset, { legend: "Zoznam čísiel proforiem" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.proforms, (proform) => {
              return (_openBlock(), _createElementBlock("div", {
                key: proform.code,
                class: "shadow-2 p-1 flex surface-card w-15rem"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(proform.code), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proform.boxes, (box, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: box.id,
                      class: "text-500 text-base font-medium"
                    }, _toDisplayString(box.code) + _toDisplayString((proform.boxes.length > index+1) ? "," : ""), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_PrimevueButton, {
                    class: "file-danger",
                    icon: "pi pi-times",
                    onClick: ($event: any) => ($options.deleteProform(proform.id)),
                    severity: "danger"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}